// extracted by mini-css-extract-plugin
module.exports = {"body":"idt-modalbody_body__3dmv7","scrollContainer":"idt-modalbody_scrollcontainer__2qof1"};